import axios from "axios";
import { requestsConstants } from '../containers/Requests/requests.constants';
import { authHeader } from '../helpers/auth-header';
import { client } from './';
import { requestListConstants } from '../containers/Requests/request-list.constants';
import { actions as expiredRequestActions } from '../actions/expired-requests.actions'
import { notificationConstants } from "../constants/notification.constants";
import appSettings from "../constants/app.constants";

export const actions = {
	getGeoData,
	getRevGeoData,
  //getRequestGeoData,
};

async function getGeoData({geoNode, completion}) {
	const url = `${appSettings.localApiUrl}/gc/`;
	try {                
		const res = await axios.post(url, geoNode, { headers: authHeader() })
		if (res.status === 200) if(completion) completion(res.data);
		else if(completion) completion([])
	}
	catch (err) {
		if(completion) completion([])
		console.log(err.request);
	}
}

async function getRequestGeoData({geoNode, completion}) {
	const corp = geoNode.corpus ? ` к${geoNode.corpus}` : '';
	//const url = `http://10.77.1.25/nominatim/search?street=${geoNode.building}${corp}+ул. ${geoNode.streetName}&city=${geoNode.city}&postalcode=&polygon_geojson=1&accept-language=ru-RU&limit=100&addressdetails=1`;
	const url = `${appSettings.localApiUrl}/gc/search?street=${geoNode.building}${corp}+ул. ${geoNode.streetName}&city=${geoNode.city}&postalcode=&polygon_geojson=1&accept-language=ru-RU&limit=100&addressdetails=1`;
	try {                
		const res = await axios.get(url, { headers: authHeader() })
		if (res.status === 200) {
			console.log(res.data)
			const houseNumber = `${geoNode.building}${corp}`;
			let r = res.data.find(e=>{				
				return e.address&&e.address.city == geoNode.city&&e.address.house_number == houseNumber+''&&e.geojson.type=='Polygon'});

			if(!r) {
				const corp = geoNode.corpus ? `/${geoNode.corpus}` : '';
				//const url = `http://10.77.1.25/nominatim/search?street=${geoNode.building}${corp}+ул. ${geoNode.streetName}&city=${geoNode.city}&postalcode=&polygon_geojson=1&accept-language=ru-RU&limit=100&addressdetails=1`;
				const url = `${appSettings.localApiUrl}/gc/search?street=${geoNode.building}${corp}+ул. ${geoNode.streetName}&city=${geoNode.city}&postalcode=&polygon_geojson=1&accept-language=ru-RU&limit=100&addressdetails=1`;
			 try {                
					const res = await axios.get(url, { headers: authHeader() })
					if (res.status === 200) {
									
						const houseNumber = `${geoNode.building}${corp}`;

						let r = res.data.find(e=>{				
	
							return e.address&&e.address.city == geoNode.city&&e.address.house_number == houseNumber+''&&e.geojson.type=='Polygon'});

							if(completion) completion(r?[r]:[])
						} else if(completion) completion([])
					}
					catch (err) {
						if(completion) completion([])
						console.log(err.request);
					}										
			}
			else if(completion) completion(r?[r]:[])
		} else if(completion) completion([])
	}
	catch (err) {
		if(completion) completion([])
		console.log(err.request);
	}
}

async function getRevGeoData({geoNode, completion}) {
	const url = `${appSettings.localApiUrl}/gc/reverse?lat=${geoNode.lat}&lon=${geoNode.lng}&format=geojson&extratags=1&addressdetails=1&accept-language=ru-RU&polygon_geojson=1`;
	try {                
		const res = await axios.get(url, { headers: authHeader() })
		if (res.status === 200) {
			if(completion) completion(res.data)
		} else if(completion) completion([])
	}
	catch (err) {
		if(completion) completion([])
		console.log(err.request);
	}
}

